import React from 'react';
import { motion } from 'framer-motion';

const Footer = () => {
  return (
    <motion.footer 
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      transition={{ duration: 0.8 }}
      viewport={{ once: true }}
      className="bg-black border-t border-gray-800 py-10 text-center text-sm text-gray-600"
    >
      <p>© 2026 Power BI Career Mastery Program. All Rights Reserved.</p>
      <div className="flex justify-center gap-6 mt-4">
        <motion.a 
          whileHover={{ color: '#F2C811', scale: 1.05 }}
          className="hover:text-pbi-yellow transition-colors cursor-pointer" 
          href="#"
        >
          Privacy Policy
        </motion.a>
        <motion.a 
          whileHover={{ color: '#F2C811', scale: 1.05 }}
          className="hover:text-pbi-yellow transition-colors cursor-pointer" 
          href="#"
        >
          Terms of Service
        </motion.a>
      </div>
    </motion.footer>
  );
};

export default Footer;